import React from 'react'

function HelpCard(props) {
    const { id, name, shortcutKey, state, disabled, underline } = props.fields
    const handleClick = () => {

        if (typeof state === 'function' && !disabled) {
            state(true);
        }
        else if (state === null && !disabled) {
            state();
        }
    }
    return (
        <div className='help_button_card mb-2' key={id} >
            <button
                className={`button_padding`}
                onClick={handleClick}
                disabled={disabled}
                style={{ background: 'white', paddingTop: 3, paddingBottom: 3, marginBottom: 2 }}
            >
                <p className='card-header'>
                    {underline ? <u className={underline === 'double' ? 'double' : 'single'}>{shortcutKey}</u> : <span>{shortcutKey}</span>}: {name}
                </p>
            </button>
        </div>
    )
}

export default HelpCard
